<div class="cards-container">
  <ng-content></ng-content>
</div>